import BasicHeroWithOutButton from './BasicHeroWithOutButton.component';

export default BasicHeroWithOutButton;